<template>
  <b-modal
    ref="modalRemoveCloudflare"
    centered
    size="md"
    title="Wait! Are you sure?"
    header-text-variant="danger"
    hide-header
    footer-bg-variant=""
    scrollable>

    <b-alert
      variant="light-danger"
      show
      class="mb-8">
      <p class="font-size-lg mb-0">
        If you request to delete Cloudflare, the deletion will be performed but will not affect current Cloudflare Proxy rules.
      </p>
    </b-alert>

    <div class="font-weight-bold mb-2">Server Details</div>
    <b-list-group
      v-if="selectedServerId !== null"
      class="mb-0">
      <b-list-group-item class="d-flex align-items-center">
        Name
        <span class="ml-auto">{{ selectedServer.name }}</span>
      </b-list-group-item>
      <b-list-group-item class="d-flex align-items-center">
        Location
        <span class="ml-auto">
          <div class="d-flex align-items-center">
            <img
              :src="countryFlag(selectedServer.country)"
              :alt="selectedServer.country"
              class="w-20px mr-2 no-select rounded-sm bg-light border border-light rounded-sm" />
            <span
              class="d-inline-block mr-1 text-truncate"
              style="max-width: 180px;">{{ countryName(selectedServer.country) }}, {{ selectedServer.location }}</span>
          </div>
        </span>
      </b-list-group-item>
      <b-list-group-item class="d-flex align-items-center">
        IP
        <span class="ml-auto">{{ selectedServer.ip }}</span>
      </b-list-group-item>
      <b-list-group-item class="d-flex align-items-center">
        Status
        <span class="ml-auto font-size-xs">
          <b-badge :variant="serverStatusBadge(selectedServer).variant">
            <i :class="`fa fa-sm fa-${serverStatusBadge(selectedServer).icon} text-white`"></i>
            {{ serverStatusBadge(selectedServer).text }}
          </b-badge>
        </span>
      </b-list-group-item>
      <b-list-group-item class="d-flex align-items-center">
        Cloudflare Proxy rules
        <span class="ml-auto">
          <span
            v-if="cloudflareInstalled"
            class="ml-auto">{{ savedCloudflareRulesLength }}</span>
          <i
            v-else
            class="fa fa-minus fa-xs opacity-50 ml-auto" />
        </span>
      </b-list-group-item>
    </b-list-group>

    <template #modal-footer>
      <div class="d-flex w-100">
        <b-button
          variant="outline-secondary"
          size="md"
          @click="hideModal('modalRemoveCloudflare')">
          Cancel
        </b-button>
        <b-button
          variant="danger"
          size="md"
          class="ml-auto"
          :disabled="serversResponses('switchCloudlfare')"
          @click="switchCloudlfare('delete', selectedServerId), hideModal('modalRemoveCloudflare')">
          Yes, delete it
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { SWITCH_CLOUDFLARE } from '@/core/services/store/servers.module'
import { mapGetters } from 'vuex'
import { eventBus } from '@/main'
import { showModal, hideModal } from '@/core/utils'

export default {
  name: 'ModalRemoveCloudflare',
  data() {
    return {
      showModal,
      hideModal,
    }
  },
  computed: {
    ...mapGetters([
      'countryFlag',
      'countryName',

      'selectedServer',
      'selectedServerId',
      'serverStatusBadge',
      'cloudflareInstalled',
      'savedCloudflareRulesLength',
      'serversResponses',
    ]),
  },
  mounted() {
    eventBus.$on('openModal', type => { this.showModal(type) })
  },
  destroyed() {
    eventBus.$off('openModal')
  },
  methods: {
    switchCloudlfare(action, server_id) {
      this.$store.dispatch(SWITCH_CLOUDFLARE, { action, server_id })
    },
  }
}
</script>
